import { Button, Card } from "antd"
import { UserCircle } from "./sidebar/task-assignees-select-popover"
import { useCurrentUser } from "hooks/current-user"
import { useCommentFormik } from "@timenotes/shared/src/services/comments/queries/use-comment-formik"
import { TextAreaField } from "components/timenotes/fields/text-area-field"
import { FormikProvider } from "formik"
import { useState } from "react"
import { SubmitShortcutInfo } from "./submit-shortcut-info"

interface Props {
  projectId: string
  taskId: string
}

export const NewTaskComment = (props: Props) => {
  const {
    projectId,
    taskId,
  } = props

  const [isFocus, setIsFocus] = useState(false)

  const formik = useCommentFormik({
    projectId,
    initialValues: {
      taskId: taskId,
    },
    onSuccess: () => {
      setIsFocus(false)
      formik.setFieldValue('content', '')
    }
  })

  const { currentUser } = useCurrentUser()
  const isActive = formik.values.content != '' || isFocus

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key == "Escape") {
      e.stopPropagation()
      e.preventDefault()

      formik.setFieldValue('content', "")
      setIsFocus(false)
    }

    if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
      e.stopPropagation()
      e.preventDefault()
      formik.submitForm()
    }
  }

  return (
    <FormikProvider value={formik}>
      <div
        style={{
          marginBottom: '20px',
        }}
      >
        <Wrapper isActive={isActive}>
          <div
            style={{
              display: 'flex',
            }}
          >
            {!isActive && (
              <div
                style={{
                  padding: '10px',
                  paddingTop: '8px',
                }}
              >
                <UserCircle>
                  {currentUser?.firstName[0]}{currentUser?.lastName[0]}
                </UserCircle>
              </div>
            )}

            <TextAreaField
              onFocus={() => setIsFocus(true)}
              onBlur={() => setIsFocus(false)}
              autoFocus={isActive}
              onKeyDown={handleKeyDown}
              name="content"
              placeholder="Add comment"
              bordered={!isActive}
              autoSize={{
                minRows: 1,
                maxRows: 4,
              }}
            />
          </div>

          {isActive && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                gap: '5px',
              }}
            >
              <SubmitShortcutInfo />

              <div>
                <Button
                  onClick={() => formik.resetForm()}
                >
                  Cancel
                </Button>

                <Button
                  onClick={formik.submitForm}
                  loading={formik.isSubmitting}
                  type='primary'
                  style={{
                    marginLeft: '5px',
                  }}
                >
                  Add
                </Button>
              </div>
            </div>
          )}

        </Wrapper>
      </div>
    </FormikProvider>
  )
}

const Wrapper = (props: React.PropsWithChildren & { isActive: boolean }) => {
  if (props.isActive) {
    return (
      <Card
        bodyStyle={{
          padding: '10px',
        }}
      >
        {props.children}
      </Card>
    )
  } else {
    return (
      <div>
        {props.children}
      </div>
    )
  }
}

